import { ProductionTypeAdditionalData, ProductionTypeInterface } from './production-type.interface';
import { SolarCalculatorRequest } from '../../../../models/analysis/solar-calculator-request';
import { ProductionType } from '../../../../../services/analysis.service';

export abstract class ToolProductionType implements ProductionTypeInterface {
  abstract getProductionType(): ProductionType;

  setRequestData(request: SolarCalculatorRequest, formValue: any, additionalData: ProductionTypeAdditionalData) {
    request.productionsHourly = additionalData.productionData;
  }

}
